import { render, staticRenderFns } from "./jindieextra.vue?vue&type=template&id=6d61295b&scoped=true&"
import script from "./jindieextra.vue?vue&type=script&lang=js&"
export * from "./jindieextra.vue?vue&type=script&lang=js&"
import style0 from "./jindieextra.vue?vue&type=style&index=0&id=6d61295b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d61295b",
  null
  
)

export default component.exports